import { useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

// Import utils
import { useEventListener } from 'components/utilities';

// Import variables
import { EVENTS_NAMES } from 'helpers/variables';
const { MOUSE_ENTER, MOUSE_LEAVE } = EVENTS_NAMES;

const useHovered = (outerRef) => {
	const innerRef = useRef();
	const supportsHover = useMediaQuery({ query: '(hover: hover)' });
	const [isHovered, setIsHovered] = useState(false);
	const ref = outerRef ?? innerRef;

	const onMouseIn = () => setIsHovered(true);
	const onMouseOut = () => setIsHovered(false);

	useEventListener(MOUSE_LEAVE, onMouseOut, ref.current);
	useEventListener(MOUSE_ENTER, onMouseIn, ref.current);

	return {
		isHovered: supportsHover && isHovered,
		supportsHover,
		ref
	};
};

export default useHovered;
